import React from 'react';

import type { ReactNode } from 'react';

import { ClearFilledIcon } from '../../../../../assets/icons';
import { ButtonSize, ButtonVariantEnum } from '../../../types/variants';
import cx from '../../../utils/classNames';
import toCamelCase from '../../../utils/toCamelCase';
import Button from '../../Button';

import styles from '../textField.module.scss';

/** Custom props */
export type TextfieldClearBtnProps = {
  /** The content of the component else we will add the default ClearSmall component there */
  children?: ReactNode;

  /** Function to handle clear button click */
  handleClearClick: () => void;

  /** Custom class to overwrite default styling if needed */
  className?: string;

  /** Controls the size of the textfield */
  size?: ButtonSize;

  /** Flag to indicate if the textfield is disabled */
  isDisabled?: boolean;
} & React.HTMLAttributes<HTMLButtonElement>;

export function ClearButton(props: TextfieldClearBtnProps) {
  const {
    className,
    children,
    size = ButtonSize.Medium,
    handleClearClick,
    isDisabled,
    ...rest
  } = props;

  return (
    <Button
      variant={ButtonVariantEnum.Ghost}
      onClick={handleClearClick}
      className={styles[toCamelCase('textField', 'clearButton')]}
      data-testid="textField-clear-button"
      isDisabled={isDisabled}
      {...rest}
    >
      {children || (
        <ClearFilledIcon
          className={cx(styles[toCamelCase('textField', 'clearIcon', size)], className)}
        />
      )}
    </Button>
  );
}

export default ClearButton;
